'use client';

import React from 'react';

const CustomHead = () => {
  const googleSiteVerification = process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION;

  return (
    <>
      {/* Page metadata is provided by each page via generateMetadata. */}
      {googleSiteVerification ? (
        <meta name='google-site-verification' content={googleSiteVerification} />
      ) : null}
      <meta name='robots' content='index, follow' />
      <meta
        name='googlebot'
        content='index, follow, noimageindex, max-video-preview:-1, max-image-preview:large, max-snippet:-1'
      />
      <meta name='category' content='technology' />
      <link rel='manifest' href='/manifest.webmanifest' />
      <link rel='icon' href='/images/app-icons/icon-16x16.png' sizes='16x16' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-32x32.png' sizes='32x32' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-57x57.png' sizes='57x57' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-76x76.png' sizes='76x76' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-114x114.png' sizes='114x114' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-120x120.png' sizes='120x120' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-144x144.png' sizes='144x144' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-150x150.png' sizes='150x150' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-152x152.png' sizes='152x152' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-180x180.png' sizes='180x180' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-192x192.png' sizes='192x192' type='image/png' />
      <link rel='icon' href='/images/app-icons/icon-512x512.png' sizes='512x512' type='image/png' />
      <link rel='shortcut icon' href='/images/app-icons/icon-76x76.png' />
      <link rel='apple-touch-icon' href='/images/app-icons/apple-touch-icon.png' />
      <link
        rel='apple-touch-icon'
        href='/images/app-icons/apple-touch-icon.png'
        sizes='180x180'
        type='image/png'
      />
      <link
        rel='apple-touch-icon-precomposed'
        href='/images/app-icons/apple-touch-icon-precomposed.png'
      />
    </>
  );
};

export default CustomHead;
